module.exports = __webpack_public_path__ + "img/PayPal.20e54f45.svg";